// "use client"

// import { useState } from "react"

// const FAQSection = () => {
//   const [activeTab, setActiveTab] = useState("tab_general_question")
//   const [activeAccordion, setActiveAccordion] = useState("collapse_1")

//   const toggleTab = (tabId) => {
//     setActiveTab(tabId)
//   }

//   const toggleAccordion = (accordionId) => {
//     setActiveAccordion(accordionId === activeAccordion ? "" : accordionId)
//   }

//   // Array of FAQ questions
//   const faqQuestions = [
//     "What is Panda Sovereign?",
//     "How is my data protected on Panda Sovereign?",
//     "Do I need special devices to use Panda Sovereign?",
//     "Can developers build dApps on Panda Sovereign?",
//     "What makes Panda Sovereign different from other identity or payment platforms?",
//   ]

//   // Array of FAQ answers
//   const faqAnswers = [
//     "Panda Sovereign is a decentralized platform that offers a secure, privacy-first digital identity system, smart contract tools, and a developer-friendly environment—no extra hardware required.",
//     "We use decentralized encryption and blockchain-grade security to ensure your identity and transactions stay private and tamper-proof, without compromising speed or usability.",
//     "No. Panda Sovereign is designed to work on any standard device—no biometric scanners or external gadgets needed. Your digital identity is accessible and secure from anywhere.",
//     "Absolutely. We provide tools, documentation, and grants for developers building privacy-first applications, smart contracts, and blockchain integrations within our ecosystem.",
//     "We offer an all-in-one ecosystem combining privacy, identity, compliance, and blockchain automation—tailored for both individuals and businesses, and shaped by community input.",
//   ]

//   // Array of questions
//   const icoQuestions = [
//     "What is the Panda Sovereign?",
//     "How do I register for the Panda Sovereign?",
//     "What is the $PANDA token?",
//     "How can I purchase $PANDA tokens?",
//     "What are the tokenomics of $PANDA?",
//   ]

//   // Array of answers
//   const icoAnswers = [
//     "The Panda Sovereign is a unique opportunity to acquire $PANDA tokens at a discounted rate before the public launch. Funds raised will support the development, expansion, and adoption of the Panda Sovereign decentralized identity and privacy ecosystem.",
//     "You can register directly through our official website. Simply create an account, complete KYC verification (if required), and follow the step-by-step instructions provided in your dashboard.",
//     "$PANDA is the native utility token of the Panda Sovereign ecosystem. It powers secure transactions, access to IDV tools, governance participation, developer incentives, and ecosystem rewards.",
//     "Once registered, you can purchase $PANDA using supported cryptocurrencies (e.g., ETH, USDT, BTC) during the phase. Accepted payment methods and wallet addresses will be provided securely via your dashboard.",
//     "The $PANDA tokenomics are designed for long-term sustainability and growth. Allocation includes public sale, development fund, team reserve, community rewards, and strategic partnerships—all detailed transparently in our whitepaper.",
//   ]

//   // Array of Token Sales questions
//   const tokenSalesQuestions = [
//     "What is the price of $PANDA tokens?",
//     "When will the $PANDA token sale begin?",
//     "Can I buy $PANDA tokens using cryptocurrency?",
//     "What is the hard cap for the $PANDA token sale?",
//     "How will the funds raised in the token sale be used?",
//   ]

//   // Array of Token Sales answers
//   const tokenSalesAnswers = [
//     "The $PANDA token will be available at an exclusive discounted rate during the phase. The price may vary across stages—early supporters will benefit from the best rates.",
//     "The Panda Sovereign  is scheduled to launch in the upcoming quarter. Official dates and phases will be announced across our verified channels—stay tuned for updates.",
//     "Yes, you can purchase $PANDA tokens using major cryptocurrencies such as ETH, USDT, and BTC. Wallet details and payment instructions will be shared in your account dashboard.",
//     "The hard cap represents the maximum funding target. Exact figures will be disclosed in the whitepaper and sale documents to ensure full transparency and trust.",
//     "Funds will be allocated toward platform development, security, community rewards, ecosystem expansion, and regulatory compliance, ensuring long-term sustainability and innovation.",
//   ]
    

//   // Array of Clients Related questions
//   const clientsRelatedQuestions = [
//     "How can I contact Panda Sovereign for support?",
//     "What services does Panda Sovereign offer to users?",
//     "How secure is the Panda Sovereign platform for users?",
//     "What is the refund policy for Panda Sovereign participants?",
//     "Are there any bonuses or rewards for $PANDA token holders?",
//   ]

//   // Array of Clients Related answers
//   const clientsRelatedAnswers = [
//     "You can reach our support team directly via our official website’s Contact Us form, email, or through our active community channels like Telegram and Discord for real-time assistance.",
//     "Panda Sovereign offers secure digital identity verification (IDV), privacy-focused transactions, smart contract tools, and a developer-friendly ecosystem—ideal for both individual users and businesses.",
//     "Security is our top priority. We use blockchain-grade encryption, decentralized architecture, and zero third-party dependencies to ensure maximum protection for user data and transactions.",
//     "Due to the nature of blockchain transactions, all token sales are final. However, we ensure full transparency before purchase, and our team is available to clarify all details before investment.",
//     "Yes! Early adopters and $PANDA holders may enjoy exclusive bonuses, airdrops, governance privileges, and access to premium platform features as part of our reward structure.",
//   ]

//   return (
//     <section className="faq_section section_space">
//       <div className="container">
//         <div className="ico_heading_block text-center" data-aos="fade-up" data-aos-duration="800">
//           <h2 className="heading_text mb-0">FAQ</h2>
//         </div>
//         <div className="tab_block" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
//           <div className="d-flex justify-content-center">
//             <ul className="nav unordered_list justify-content-md-center" role="tablist">
//               <li className="nav-item" role="presentation">
//                 <button
//                   className={`nav-link ${activeTab === "tab_general_question" ? "active" : ""}`}
//                   type="button"
//                   role="tab"
//                   onClick={() => toggleTab("tab_general_question")}
//                 >
//                   General Question
//                 </button>
//               </li>
//               <li className="nav-item" role="presentation">
//                 <button
//                   className={`nav-link ${activeTab === "tab_ico_questions" ? "active" : ""}`}
//                   type="button"
//                   role="tab"
//                   onClick={() => toggleTab("tab_ico_questions")}
//                 >
//                   Essentials
//                 </button>
//               </li>
//               <li className="nav-item" role="presentation">
//                 <button
//                   className={`nav-link ${activeTab === "tab_tokens_sales" ? "active" : ""}`}
//                   type="button"
//                   role="tab"
//                   onClick={() => toggleTab("tab_tokens_sales")}
//                 >
//                   Tokens Sales
//                 </button>
//               </li>
//               <li className="nav-item" role="presentation">
//                 <button
//                   className={`nav-link ${activeTab === "tab_clients_releted" ? "active" : ""}`}
//                   type="button"
//                   role="tab"
//                   onClick={() => toggleTab("tab_clients_releted")}
//                 >
//                   Clients Related
//                 </button>
//               </li>
//             </ul>
//           </div>
//           <div className="tab-content">
//             {/* General Question Tab */}
//             <div
//               className={`tab-pane fade ${activeTab === "tab_general_question" ? "show active" : ""}`}
//               role="tabpanel"
//               id="tab_general_question"
//             >
//               <div className="ico_accordion" id="accordion_1">
//                 {faqQuestions.map((question, index) => {
//                   const collapseId = `collapse_${index + 1}`
//                   return (
//                     <div className="accordion-item" key={collapseId}>
//                       <div
//                         className={`icon_arrow ${activeAccordion === collapseId ? "collapsed" : ""}`}
//                         role="button"
//                         onClick={() => toggleAccordion(collapseId)}
//                       >
//                         <svg viewBox="0 0 23 27" xmlns="http://www.w3.org/2000/svg">
//                           <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
//                           <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
//                           <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
//                         </svg>
//                       </div>
//                       <div
//                         className={`accordion-button ${activeAccordion === collapseId ? "" : "collapsed"}`}
//                         role="button"
//                         onClick={() => toggleAccordion(collapseId)}
//                       >
//                         {`${index + 1}- ${question}`}
//                       </div>
//                       <div
//                         id={collapseId}
//                         className={`accordion-collapse collapse ${activeAccordion === collapseId ? "show" : ""}`}
//                         data-bs-parent="#accordion_1"
//                       >
//                         <div className="accordion-body">
//                           <p>{faqAnswers[index]}</p>
//                           <ul className="iconlist_block unordered_list_block">
//                             <li>
//                               <span className="iconlist_icon">
//                                 <i className="fa-solid fa-circle"></i>
//                               </span>
//                               <span className="iconlist_label">Sign up and complete the KYC process.</span>
//                             </li>
//                             <li>
//                               <span className="iconlist_icon">
//                                 <i className="fa-solid fa-circle"></i>
//                               </span>
//                               <span className="iconlist_label">Follow instructions to purchase tokens securely.</span>
//                             </li>
//                           </ul>
//                         </div>
//                       </div>
//                     </div>
//                   )
//                 })}
//               </div>
//             </div>
//             {/* ICO Questions Tab */}
//             <div
//               className={`tab-pane fade ${activeTab === "tab_ico_questions" ? "show active" : ""}`}
//               role="tabpanel"
//               id="tab_ico_questions"
//             >
//               <div className="ico_accordion" id="accordion_2">
//                 {icoQuestions.map((question, index) => {
//                   const collapseId = `collapse_ico_${index + 1}`
//                   return (
//                     <div className="accordion-item" key={collapseId}>
//                       <div
//                         className={`icon_arrow ${activeAccordion === collapseId ? "collapsed" : ""}`}
//                         role="button"
//                         onClick={() => toggleAccordion(collapseId)}
//                       >
//                         <svg viewBox="0 0 23 27" xmlns="http://www.w3.org/2000/svg">
//                           <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
//                           <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
//                           <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
//                         </svg>
//                       </div>
//                       <div
//                         className={`accordion-button ${activeAccordion === collapseId ? "" : "collapsed"}`}
//                         role="button"
//                         onClick={() => toggleAccordion(collapseId)}
//                       >
//                         {`${index + 1}- ${question}`}
//                       </div>
//                       <div
//                         id={collapseId}
//                         className={`accordion-collapse collapse ${activeAccordion === collapseId ? "show" : ""}`}
//                         data-bs-parent="#accordion_2"
//                       >
//                         <div className="accordion-body">
//                           <p>{icoAnswers[index]}</p>
//                         </div>
//                       </div>
//                     </div>
//                   )
//                 })}
//               </div>
//             </div>
//             {/* Tokens Sales Tab */}
//             <div
//               className={`tab-pane fade ${activeTab === "tab_tokens_sales" ? "show active" : ""}`}
//               role="tabpanel"
//               id="tab_tokens_sales"
//             >
//               <div className="ico_accordion" id="accordion_3">
//                 {tokenSalesQuestions.map((question, index) => {
//                   const collapseId = `collapse_token_sales_${index + 1}`
//                   return (
//                     <div className="accordion-item" key={collapseId}>
//                       <div
//                         className={`icon_arrow ${activeAccordion === collapseId ? "collapsed" : ""}`}
//                         role="button"
//                         onClick={() => toggleAccordion(collapseId)}
//                       >
//                         <svg viewBox="0 0 23 27" xmlns="http://www.w3.org/2000/svg">
//                           <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
//                           <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
//                           <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
//                         </svg>
//                       </div>
//                       <div
//                         className={`accordion-button ${activeAccordion === collapseId ? "" : "collapsed"}`}
//                         role="button"
//                         onClick={() => toggleAccordion(collapseId)}
//                       >
//                         {`${index + 1}- ${question}`}
//                       </div>
//                       <div
//                         id={collapseId}
//                         className={`accordion-collapse collapse ${activeAccordion === collapseId ? "show" : ""}`}
//                         data-bs-parent="#accordion_3"
//                       >
//                         <div className="accordion-body">
//                           <p>{tokenSalesAnswers[index]}</p>
//                         </div>
//                       </div>
//                     </div>
//                   )
//                 })}
//               </div>
//             </div>
//             {/* Clients Related Tab */}
//             <div
//               className={`tab-pane fade ${activeTab === "tab_clients_releted" ? "show active" : ""}`}
//               role="tabpanel"
//               id="tab_clients_releted"
//             >
//               <div className="ico_accordion" id="accordion_4">
//                 {clientsRelatedQuestions.map((question, index) => {
//                   const collapseId = `collapse_clients_${index + 1}`
//                   return (
//                     <div className="accordion-item" key={collapseId}>
//                       <div
//                         className={`icon_arrow ${activeAccordion === collapseId ? "collapsed" : ""}`}
//                         role="button"
//                         onClick={() => toggleAccordion(collapseId)}
//                       >
//                         <svg viewBox="0 0 23 27" xmlns="http://www.w3.org/2000/svg">
//                           <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
//                           <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
//                           <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
//                         </svg>
//                       </div>
//                       <div
//                         className={`accordion-button ${activeAccordion === collapseId ? "" : "collapsed"}`}
//                         role="button"
//                         onClick={() => toggleAccordion(collapseId)}
//                       >
//                         {`${index + 1}- ${question}`}
//                       </div>
//                       <div
//                         id={collapseId}
//                         className={`accordion-collapse collapse ${activeAccordion === collapseId ? "show" : ""}`}
//                         data-bs-parent="#accordion_4"
//                       >
//                         <div className="accordion-body">
//                           <p>{clientsRelatedAnswers[index]}</p>
//                         </div>
//                       </div>
//                     </div>
//                   )
//                 })}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   )
// }

// export default FAQSection

"use client"

import { useState } from "react"
import { useApi } from "../../hooks/useApi"

const FAQSection = () => {
  const [activeTab, setActiveTab] = useState("tab_general_question")
  const [activeAccordion, setActiveAccordion] = useState("collapse_1")
  const { data: faqData, loading, error } = useApi("/faq")
console.log(faqData,"LKLKL")
  const toggleTab = (tabId) => {
    setActiveTab(tabId)
  }
console.log(activeAccordion,activeTab,"wwwwwwwwwww")
  const toggleAccordion = (accordionId) => {
    setActiveAccordion(accordionId === activeAccordion ? "" : accordionId)
  }

  if (loading) {
    return (
      <section className="faq_section section_space">
        <div className="container">
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </section>
    )
  }

  if (error || !faqData) {
    return null
  }

  return (
    <section className="faq_section section_space">
      <div className="container">
        <div className="ico_heading_block text-center" data-aos="fade-up" data-aos-duration="800">
          <h2 className="heading_text mb-0">{faqData.heading}</h2>
        </div>
        <div className="tab_block" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
          <div className="d-flex justify-content-center">
            <ul className="nav unordered_list justify-content-md-center" role="tablist">
              {faqData.categories?.map((category, index) => (
                <li key={index} className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === category._id ? "active " : ""}`}
                    type="button"
                    role="tab"
                    onClick={() => toggleTab(category._id)}
                  >
                    {category.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="tab-content">
            {faqData.categories?.map((category, categoryIndex) => (
              <div
                key={categoryIndex}
                className={`tab-pane fade ${activeTab === category._id ? "show active" : ""}`}
                role="tabpanel"
                id={category.id}
              >
                <div className="ico_accordion" id={`accordion_${categoryIndex + 1}`}>
                  {category.questions?.map((faq, index) => {
                    const collapseId = `collapse_${category._id}_${index + 1}`
                    return (
                      <div className="accordion-item" key={collapseId}>
                        <div
                          className={`icon_arrow ${activeAccordion === collapseId ? "collapsed" : ""}`}
                          role="button"
                          onClick={() => toggleAccordion(collapseId)}
                        >
                          <svg viewBox="0 0 23 27" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
                            <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
                            <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
                          </svg>
                        </div>
                        <div
                          className={`accordion-button ${activeAccordion === collapseId ? "" : "collapsed"}`}
                          role="button"
                          onClick={() => toggleAccordion(collapseId)}
                        >
                          {`${index + 1}- ${faq.question}`}
                        </div>
                        <div
                          id={collapseId}
                          className={`accordion-collapse collapse ${activeAccordion === collapseId ? "show" : ""}`}
                          data-bs-parent={`#accordion_${categoryIndex + 1}`}
                        >
                          <div className="accordion-body">
                            <p>{faq.answer}</p>
                            {faq.additionalInfo && (
                              <ul className="iconlist_block unordered_list_block">
                                {faq.additionalInfo.map((info, infoIndex) => (
                                  <li key={infoIndex}>
                                    <span className="iconlist_icon">
                                      <i className="fa-solid fa-circle"></i>
                                    </span>
                                    <span className="iconlist_label">{info}</span>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default FAQSection
